import React from 'react';
import PropTypes from 'prop-types';

export const Controls = ({ children, controlsRef }) => (
	<div ref={controlsRef}> {children} </div>
);

Controls.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired,
	controlsRef: PropTypes.object
};

Controls.defaultProps = {
	controlsRef: null
};

export default Controls;
export { default as ControlsBlock } from './components/Block';
export { default as ControlsRow } from './components/Row';
